import React from "react";
import Select from "react-select";
import countries from "../../utils/countries.json";
import Asterisk from "../../utils/Asterisk";
import { useFormCtx } from "../../../context/formContext/formContext";

const FormCountries = ({
  htmlFor,
  label,
  required,
  name,
  relative,
  top,
  inputColor,
  value,
  error,
  touched,
}) => {
  const { fillCoporateInfo } = useFormCtx();

  const countryOptions = countries.map((country) => ({
    value: country.name,
    label: country.name,
  }));

  const handleChange = (selectedOption) => {
    const fakeEvent = {
      target: {
        name,
        value: selectedOption ? selectedOption.value : "",
      },
    };
    fillCoporateInfo(fakeEvent);
  };

  const getSelectStyles = () => {
    let customStyles = "text-black font-bold";

    if (error && touched) {
      customStyles += " border-red-500";
    } else if (required && !value && touched) {
      customStyles += " border-red-500";
    }

    return customStyles;
  };

  return (
    <div className={`form-group ${relative} ${top} w-full md:w-1/2`}>
      <div className="flex flex-col">
        <label htmlFor={htmlFor} className="flex items-center">
          <span
            className={`font-bold ${inputColor ? "text-white" : "text-black"}`}
          >
            {label}
          </span>
          <span>
            <Asterisk required={required} />
          </span>
        </label>
        <Select
          id={htmlFor}
          name={name}
          value={
            countryOptions.find((option) => option.value === value) || null
          }
          onChange={handleChange}
          options={countryOptions}
          placeholder="Select a country"
          isSearchable
          className={getSelectStyles()}
          classNamePrefix="react-select"
          aria-required={required}
          aria-invalid={required && !value ? true : false}
          required={required}
          onBlur={() => {
            if (required && !value) {
              const blurEvent = {
                target: {
                  name,
                  value: "",
                },
              };
              fillCoporateInfo(blurEvent);
            }
          }}
        />
        {(error && touched) || (required && !value && touched) ? (
          <span className="text-red-500 text-sm mt-1">
            {error || `${label} is required`}
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default FormCountries;
